import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import styled from "styled-components";

const StyledExpansionPanelSummary = styled(ExpansionPanelSummary)`
  padding: 0;
`;

export default StyledExpansionPanelSummary;
